import { useContext } from 'react';

import { DefaultHeaderMobileLoginFormContext } from '../../components/_shared/header/default-header/default-header-mobile-login-form/default-header-mobile-login-form-context/default-header-mobile-login-form-context';

export const useDefaultHeaderMobileLoginContext = () =>
    useContext(DefaultHeaderMobileLoginFormContext);
